import { render } from "./ResponsableAsignarListado.vue?vue&type=template&id=3620a06a"
import script from "./ResponsableAsignarListado.vue?vue&type=script&lang=js"
export * from "./ResponsableAsignarListado.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__